const myElement = document.querySelector('.klaviyo-form-UKYUsv');

window.addEventListener('scroll', () => {
  const scrollPosition = window.scrollY;
  const pageHeight = document.body.scrollHeight - window.innerHeight;
  const scrollPercentage = (scrollPosition / pageHeight) * 100;
  document.getElementById('myBar').style.width = `${scrollPercentage}%`;

  if (isInViewport(myElement, scrollPercentage)) {

  }
});

// change color on scroll


const isInViewport = (elem) => {
  const bounding = elem.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  );
}

// random number between 1 - 10

